import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bike-reset" }

import { BfButton, ButtonType } from '@finetic/bikefitting-ui'
import { useMessage } from 'naive-ui'
import { usePreferenceStore } from '@/store/preferenceStore'
import { useMqttStore } from '@/store/mqttStore'
import { usePositionStore } from '@/store/positionStore'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'BikeFunctions',
  setup(__props) {

const router = useRouter()
const preferenceStore = usePreferenceStore()
const mqttStore = useMqttStore()
const positionStore = usePositionStore()
const message = useMessage()

const { t } = useI18n()

const { destroyConnection } = mqttStore
const { resetPosition, startHoming, doResetMotors, doReboot, doShutdown } =
  positionStore

const { hasPositioningMotors } = storeToRefs(preferenceStore)
const { client } = storeToRefs(mqttStore)

const homing = () => {
  startHoming()
  message.loading(t('common.fitbike.homing'))
}

const resetMotors = () => {
  doResetMotors()
  message.loading(t('common.fitbike.resetMotors'))
}

const reboot = () => {
  doReboot()
  resetApp()
  message.loading(t('common.fitbike.reboot'))
}

const shutdown = () => {
  doShutdown()
  resetApp()
  message.loading(t('common.fitbike.shutdown'))
}

const resetApp = () => {
  destroyConnection(client.value)
  resetPosition()
  router.push({ name: 'start' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(hasPositioningMotors))
      ? (_openBlock(), _createBlock(_unref(BfButton), {
          key: 0,
          type: _unref(ButtonType).Outlined,
          onClick: homing
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('common.homing')), 1)
          ]),
          _: 1
        }, 8, ["type"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(BfButton), {
      type: _unref(ButtonType).Outlined,
      onClick: resetMotors
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('common.resetMotors')), 1)
      ]),
      _: 1
    }, 8, ["type"]),
    _createVNode(_unref(BfButton), {
      type: _unref(ButtonType).Outlined,
      onClick: reboot
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('common.reboot')), 1)
      ]),
      _: 1
    }, 8, ["type"]),
    _createVNode(_unref(BfButton), {
      type: _unref(ButtonType).Outlined,
      onClick: shutdown
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('common.shutdown')), 1)
      ]),
      _: 1
    }, 8, ["type"])
  ]))
}
}

})